import { 
    BULK_TEXT_GET_FAILURE,
    BULK_TEXT_GET_REQUEST,
    BULK_TEXT_GET_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
  bulkTextTransaction: [],
  loading: false,
  error: null,
};

const bulkTextTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case BULK_TEXT_GET_REQUEST:
      return { ...state, loading: true, error: null };
      
    case BULK_TEXT_GET_SUCCESS:
      return { ...state, loading: false, bulkTextTransaction: action.payload.data };

    case BULK_TEXT_GET_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default bulkTextTransactionReducer;




